import {ResponsiveImage} from "@olivades/pattern-lib";
import {environment} from "../../environments/environment";

function createResponsiveImage(image: Partial<ResponsiveImage>): ResponsiveImage {
  const imageName = image.imageName!;
  const folderPath = image.folderPath!;
    return {
      name: image.name || "",
      alt: image.alt || "",
      title: image.title || "",
      copyright: image.copyright || "",
      folderPath,
      imageName,
      filename: `${environment.cdnUrl}${folderPath}${image.imageName}`,
  };
}

const imagesPath = '/images/'
const logoPath = '/Logo/COULEUR/'
export const logo = createResponsiveImage({imageName: "Logo_Couleur.png",  folderPath: logoPath})
export const introPhoto = createResponsiveImage({imageName: "rm-drone.webp",  folderPath: imagesPath})
export const aboutPhoto = createResponsiveImage({imageName: "rm-about.webp",  folderPath: imagesPath})
export const contactPhoto = createResponsiveImage({imageName: "les-baux-de-provence_alpilles_adobestock_132723497.webp",  folderPath: imagesPath})

const roomFolderPath = "/images/rentals/room/x2000/"
export const mainPhotoRoom = createResponsiveImage({imageName: "photo-chambre-principal.webp",  folderPath: roomFolderPath})
const roomImg: Partial<ResponsiveImage>[] = [
  { imageName: "photo-chambre-gallery-1.webp", folderPath: roomFolderPath},
  { imageName: "photo-chambre-gallery-2.webp", folderPath: roomFolderPath},
  { imageName: "photo-chambre-gallery-3.webp", folderPath: roomFolderPath},
  { imageName: "photo-chambre-gallery-4.webp", folderPath: roomFolderPath},
  { imageName: "photo-chambre-gallery-5.webp", folderPath: roomFolderPath},
  { imageName: "photo-chambre-gallery-6.webp", folderPath: roomFolderPath},
  { imageName: "photo-chambre-gallery-7.webp", folderPath: roomFolderPath},
  { imageName: "photo-chambre-gallery-8.webp", folderPath: roomFolderPath},
  { imageName: "photo-chambre-gallery-9.webp", folderPath: roomFolderPath},
]
const baseRoomPhoto = roomImg.map(img => createResponsiveImage(img))


const st1FolderPath = "/images/rentals/st1/x2000/"
export const mainPhotoStudio1 = createResponsiveImage({imageName: "photo-st1-principal.webp",  folderPath: st1FolderPath})
const st1Img: Partial<ResponsiveImage>[] = [
  { imageName: "photo-st1-gallery-1.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-2.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-3.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-4.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-5.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-6.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-7.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-8.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-9.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-11.webp", folderPath: st1FolderPath},
  { imageName: "photo-st1-gallery-11.webp", folderPath: st1FolderPath},
]
const baseStudio1Photo = st1Img.map(img => createResponsiveImage(img))


const studioFolderPath = "/images/rentals/studio/x2000/"
export const mainPhotoStudio = createResponsiveImage({imageName: "photo-studio-principal.webp",  folderPath: studioFolderPath})
const studioImg: Partial<ResponsiveImage>[] = [
  { imageName: "photo-studio-gallery-1.webp", folderPath: studioFolderPath},
  { imageName: "photo-studio-gallery-2.webp", folderPath: studioFolderPath},
  { imageName: "photo-studio-gallery-3.webp", folderPath: studioFolderPath},
  { imageName: "photo-studio-gallery-4.webp", folderPath: studioFolderPath},
  { imageName: "photo-studio-gallery-5.webp", folderPath: studioFolderPath},
  { imageName: "photo-studio-gallery-6.webp", folderPath: studioFolderPath},
  { imageName: "photo-studio-gallery-7.webp", folderPath: studioFolderPath},
  { imageName: "photo-studio-gallery-8.webp", folderPath: studioFolderPath},
]
const baseStudioPhoto = studioImg.map(img => createResponsiveImage(img))


const st6FolderPath = "/images/rentals/st6/x2000/"
export const mainPhotoStudio6 = createResponsiveImage({imageName: "photo-st6-principal.webp",  folderPath: st6FolderPath})
const st6Img: Partial<ResponsiveImage>[] = [
  { imageName: "photo-st6-gallery-1.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-2.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-3.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-4.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-5.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-8.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-9.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-10.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-11.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-12.webp", folderPath: st6FolderPath},
  { imageName: "photo-st6-gallery-13.webp", folderPath: st6FolderPath},
]
const baseStudio6photo = st6Img.map(img => createResponsiveImage(img))


const apt1FolderPath = "/images/rentals/apt1/x2000/"
export const mainPhotoApt1 = createResponsiveImage({imageName: "photo-apt1-principal.webp",  folderPath: apt1FolderPath})
const apt1Img: Partial<ResponsiveImage>[] = [
  { imageName: "photo-apt1-gallery-1.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-2.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-3.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-4.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-5.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-6.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-7.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-8.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-9.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-10.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-11.webp", folderPath: apt1FolderPath},
  { imageName: "photo-apt1-gallery-12.webp", folderPath: apt1FolderPath},
]
const baseApt1Photo = apt1Img.map(img => createResponsiveImage(img))

const apt2FolderPath = "/images/rentals/apt2/x2000/"
export const mainPhotoApt2 = createResponsiveImage({imageName: "IMG_9304.webp",  folderPath: apt2FolderPath})
const apt2Img: Partial<ResponsiveImage>[] = [
  { imageName: "IMG_9301.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9303.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9309.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9312.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9310.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9311.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9302.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9313.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9314.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9316.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9317.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9318.webp", folderPath: apt2FolderPath},
  { imageName: "IMG_9320.webp", folderPath: apt2FolderPath},

]
const baseApt2Photo = apt2Img.map(img => createResponsiveImage(img))

const poolFolderPath = "/images/piscine/x2000/"
const poolImg: Partial<ResponsiveImage>[] = [
  { imageName: "photo-piscine-1.webp", folderPath: poolFolderPath},
  { imageName: "photo-piscine-2.webp", folderPath: poolFolderPath},
  { imageName: "photo-piscine-3.webp", folderPath: poolFolderPath},
  { imageName: "photo-piscine-4.webp", folderPath: poolFolderPath},
  { imageName: "photo-piscine-5.webp", folderPath: poolFolderPath},
  { imageName: "photo-piscine-6.webp", folderPath: poolFolderPath},
]
const poolPhoto = poolImg.map(img => createResponsiveImage(img))


const gardenFolderPath = "/images/jardin/x2000/"
const gardenImg: Partial<ResponsiveImage>[] = [
  { imageName: "photo-jardin-1.webp", folderPath: gardenFolderPath},
  { imageName: "photo-jardin-2.webp", folderPath: gardenFolderPath},
  { imageName: "photo-jardin-3.webp", folderPath: gardenFolderPath},
  { imageName: "photo-jardin-4.webp", folderPath: gardenFolderPath},
  { imageName: "photo-jardin-5.webp", folderPath: gardenFolderPath},
]
const gardenPhoto = gardenImg.map(img => createResponsiveImage(img))


export const roomPhotos: ResponsiveImage[] =  [
  ...baseRoomPhoto,
  ...poolPhoto,
  ...gardenPhoto
]

export const studio1Photos: ResponsiveImage[] = [
  ...baseStudio1Photo,
  ...poolPhoto,
  ...gardenPhoto
]

export const studioPhotos: ResponsiveImage[] = [
  ...baseStudioPhoto,
  ...poolPhoto,
  ...gardenPhoto
]

export const studio6photos: ResponsiveImage[] = [
  ...baseStudio6photo,
  ...poolPhoto,
  ...gardenPhoto
]

export const apt1Photos: ResponsiveImage[] = [
  ...baseApt1Photo,
  ...poolPhoto,
  ...gardenPhoto
];

export const apt2Photos: ResponsiveImage[] = [
  ...baseApt2Photo,
  ...poolPhoto,
  ...gardenPhoto
];

export const photoTab = [
  {
    name: 'gallery.photoTabs.garden',
    assets: gardenPhoto,
    className: 'garden',
  },
  {
    name: 'gallery.photoTabs.appartment',
    assets: [
      ...baseApt1Photo,
      ...baseStudio6photo,
      ...baseStudio1Photo,
      ...baseStudioPhoto,
    ],
    className: 'appartment',
  },
  {
    name: 'gallery.photoTabs.pool',
    assets: poolPhoto,
    className: 'pool',
  },
  {
    name: 'gallery.photoTabs.room',
    assets: baseRoomPhoto,
    className: 'room',
  }
];
